import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CheckoutSuccessPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [orderStatus, setOrderStatus] = useState(null);
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("sessionId");
  const orderId = searchParams.get("orderId");
  useEffect(() => {
    const updateOrder = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/Order/${orderId}/Success`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ status: sessionId }),
          }
        );

        if (!response.ok) {
          throw new Error("Erreur lors de la mise à jour de la commande");
        }

        const data = await response.json();
        setOrderStatus(data.status); // Par exemple, tu peux récupérer un statut ou d'autres infos
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    updateOrder();
  }, [sessionId]);

  if (loading) {
    return <div>{t("loading")}</div>;
  }

  if (error) {
    return <div>{t("error", { message: error })}</div>;
  }

  return (
    <div className="flex flex-col">
      <div className="h-[36rem] flex bg-gradient-to-l from-primary via-[#4d9fa3] via-[#93E7F3] to-primary items-center justify-center p-6">
        <div className="bg-white p-8 rounded-lg shadow-xl max-w-xl w-full">
          <div className="text-center">
            <h1 className="text-4xl font-extrabold text-[#2d3748]">
              {t("cart.thank_you")}
            </h1>

            <p className="mt-4 text-2xl font-medium text-gray-700">
              {t("cart.order_created")}
            </p>

            <div className="mt-8 space-y-6">
              <div className="flex justify-center mt-6">
                <div className="celebration-animation text-5xl animate-bounce">
                  🎉
                </div>
              </div>

              <p className="mt-4 text-onWhite font-medium text-lg">
                {t("cart.celebration")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSuccessPage;
